export class DateFromString {
  public static OnFilterApplied(input: string, format?: string) {
    return moment(input).format(format ? format : 'DD MMM YYYY');
  }
}